import _ from 'lodash';
import loadModule from './wasm/cophi.js';

const computeCanvasSize = () => {
    const canvas = document.getElementById('canvas');
    const container = document.getElementById('canvas-container');
    // https://www.khronos.org/webgl/wiki/HandlingHighDPI
    const devicePixelRatio = window.devicePixelRatio || 1;
    canvas.width = container.clientWidth * devicePixelRatio;
    canvas.height = container.clientHeight * devicePixelRatio;
    return {width: container.clientWidth * devicePixelRatio, height: container.clientHeight * devicePixelRatio};
}

export default () => {
    let module = {}

    module.print = (...theArgs) => {
        console.info(Array.prototype.slice.call(theArgs).join(' '));
    }

    module.printErr = (...theArgs) => {
        console.error(Array.prototype.slice.call(theArgs).join(' '));
    }

    module.canvas = (function () {
        return document.getElementById('canvas');
    })()

    module.onError = error => {
        console.error('CORE:', error);
    };

    module = loadModule(module);
    module.onResize = () => {
        const sizes = computeCanvasSize();
        module.onReshape(sizes.width, sizes.height);
        module.fit();
    };
    module.postRun = [() => {
        window.onresize = _.debounce(() => {
            module.onResize();
        }, 500);
        module.onResize();
        module.running = true;
    }];
    return module

};

